import { action_options, app_modules } from "helpers/apps_modules_list";
import WarehouseList from "pages/Master/Warehouse/List/WarehouseList";
import Category from "pages/Master/Category/List/Category";
import CategoryForm from "pages/Master/Category/Form/CategoryForm";
import Gst from "pages/Master/GST/List/GST";
import GSTForm from "pages/Master/GST/Form/GSTForm";
import HSNCode from "pages/Master/HSNCode/List/HSNCode";
import HSNCodeForm from "pages/Master/HSNCode/Form/HSNCodeForm";
import SubCategory from "pages/Master/Sub-Category/List/Sub-Category";
import SubCategoryForm from "pages/Master/Sub-Category/Form/Sub-CategoryForm";
import SubCategorEditForm from "pages/Master/Sub-Category/Form/SubCategoryEditForm";
import Type from "pages/Master/Type/List/Type";
import TypeForm from "pages/Master/Type/Form/TypeForm";
import UOM from "pages/Master/UOM/List/UOM";
import UOMForm from "pages/Master/UOM/Form/UOMForm";
import Company from "pages/Master/Company/List/Company";
import CompanyForm from "pages/Master/Company/Form/CompanyForm";
import CompanyViewPage from "pages/Master/Company/View/CompanyViewPage";
import Currency from "pages/Master/Currency/List/Currency";
import CurrencyForm from "pages/Master/Currency/Form/CurrencyForm";
import Make from "pages/Master/Make/List/Make";
import MakeForm from "pages/Master/Make/Form/MakeForm";
import Model from "pages/Master/Model/List/Model";
import ModelForm from "pages/Master/Model/Form/ModelForm";
import Products from "pages/Master/product/List/index";
import ProductForm from "pages/Master/product/Form/ProductForm";
import ProductView from "pages/Master/product/View/ProductView";
import TermsAndCondition from "pages/Master/TermsAndCondition/List/TermsAndCondition";
import TermsAndConditionForm from "pages/Master/TermsAndCondition/Form/TermsAndConditionForm";
import SupplierList from "pages/Master/Supplier/List";
import SupplierForm from "pages/Master/Supplier/Form";
import SupplierViewDetails from "pages/Master/Supplier/ViewDetails";
import ConfigureWarehouse from "pages/Master/Warehouse/Form/AddConfigarations";
import AddWarehouseForm from "pages/Master/Warehouse/Form/Addwarehosue";
import SACCode from "pages/Master/SACCode/List/SACCode";
import SACCodeForm from "pages/Master/SACCode/Form/SACCodeForm";
import SettingsPage from "pages/Settings";


const MastersRoutes: any = [
  // Category Routes
  {
    path: "master/category",
    component: <Category />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-category",
    component: <CategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-category/:id",
    component: <CategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options?.update,
    },
  },

  // Sub Category
  {
    path: "master/sub-category",
    component: <SubCategory />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.subcategory,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-sub-category",
    component: <SubCategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.subcategory,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-sub-category/:id",
    component: <SubCategorEditForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.subcategory,
      action: action_options?.update,
    },
  },

  // Type
  {
    path: "master/type",
    component: <Type />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.type,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-type",
    component: <TypeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.type,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-type/:id",
    component: <TypeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.type,
      action: action_options?.update,
    },
  },

  // UOM
  {
    path: "master/uom",
    component: <UOM />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.unit,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-uom",
    component: <UOMForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.unit,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-uom/:id",
    component: <UOMForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.unit,
      action: action_options?.update,
    },
  },

  // GST
  {
    path: "master/gst",
    component: <Gst />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.gst,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-gst",
    component: <GSTForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.gst,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-gst/:id",
    component: <GSTForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.gst,
      action: action_options?.update,
    },
  },

  // HSN
  {
    path: "master/hsn-codes",
    component: <HSNCode />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.hsn_code,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-hsn-code",
    component: <HSNCodeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.hsn_code,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-hsn-code/:id",
    component: <HSNCodeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.hsn_code,
      action: action_options?.update,
    },
  },

  // SAC Code

  {
    path: "master/sac-codes",
    component: <SACCode />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.sac_code,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-sac-code",
    component: <SACCodeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.sac_code,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-sac-code/:id",
    component: <SACCodeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.sac_code,
      action: action_options?.update,
    },
  },
  // Currency
  {
    path: "master/currency",
    component: <Currency />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.currency,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-currency",
    component: <CurrencyForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.currency,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-currency/:id",
    component: <CurrencyForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.currency,
      action: action_options?.update,
    },
  },

  // Make
  {
    path: "master/make",
    component: <Make />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.make,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-make",
    component: <MakeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.make,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-make/:id",
    component: <MakeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.make,
      action: action_options?.update,
    },
  },

  // Model
  {
    path: "master/model",
    component: <Model />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.model,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-model",
    component: <ModelForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.model,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-model/:id",
    component: <ModelForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.model,
      action: action_options?.update,
    },
  },

  // Company (Customer)
  {
    path: "/master/company",
    component: <Company />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.view,
    },
  },
  {
    path: "/master/add-company",
    component: <CompanyForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.create,
    },
  },
  {
    path: "/master/edit-company/:id",
    component: <CompanyForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.update,
    },
  },
  {
    path: "/master/company/view/:id",
    component: <CompanyViewPage />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.view,
    },
  },

  // Product
  {
    path: "master/product",
    component: <Products />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.product,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-product",
    component: <ProductForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.product,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-product/:id",
    component: <ProductForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.product,
      action: action_options?.update,
    },
  },
  {
    path: "master/product/view/:id",
    component: <ProductView />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.product,
      action: action_options?.view,
    },
  },

  // Supplier
  {
    path: "master/supplier",
    component: <SupplierList />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.supplier,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-supplier",
    component: <SupplierForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.supplier,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-supplier/:id",
    component: <SupplierForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.supplier,
      action: action_options?.update,
    },
  },
  {
    path: "master/view-supplier/:id",
    component: <SupplierViewDetails />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.supplier,
      action: action_options?.view,
    },
  },

  // Terms and Condition
  {
    path: "master/terms-and-condition",
    component: <TermsAndCondition />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.terms_and_conditions,
      action: action_options?.view,
    },
  },
  {
    path: "master/add-terms-and-condition",
    component: <TermsAndConditionForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.terms_and_conditions,
      action: action_options?.create,
    },
  },
  {
    path: "master/edit-terms-and-condition/:id",
    component: <TermsAndConditionForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.terms_and_conditions,
      action: action_options?.update,
    },
  },

  // Settings (no route-level permission; API enforces view permission)
  {
    path: "/master/settings",
    component: <SettingsPage />,
    permissions: undefined,
  },

  // Warehouse
  {
    path: "/master/warehouse-list",
    name: "Warehouse",
    component: <WarehouseList />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.warehouse,
      action: action_options?.view,
    },
  },
  {
    path: "/master/warehouse-form",
    name: "Warehouse",
    component: <AddWarehouseForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.warehouse,
      action: action_options?.create,
    },
  },
  {
    path: "/master/warehouse-forms/:id",
    name: "WarehouseEdit",
    component: <AddWarehouseForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.warehouse,
      action: action_options?.update,
    },
  },
  {
    path: "/master/configure-warehouse/:id",
    name: "Warehouse",
    component: <ConfigureWarehouse />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.warehouse,
      action: action_options?.update,
    },
  },
];

export default MastersRoutes;
